import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';
import { EntityId } from 'services/entities/types';
import { makeSelectTimesheetIsHoliday } from './selectors';

export interface OwnProps {
    children: React.ReactElement | string;
    timesheetDate: TimesheetHolidayDate;
    timesheetEntityId?: EntityId;
    fallback?: React.ReactElement | string;
}

interface ConnectedProps {
    timesheetDateIsHoliday?: boolean;
}

export type Props = OwnProps & ConnectedProps;

export class TimesheetHolidayGateComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | string | null {
        const { timesheetDateIsHoliday, children, fallback } = this.props;

        if (timesheetDateIsHoliday) {
            return children;
        }

        if (fallback) {
            return fallback;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    timesheetDateIsHoliday: makeSelectTimesheetIsHoliday()
});

export default connect(mapStateToProps)(TimesheetHolidayGateComponent);
